import classNames from "classnames";

export function formLabelTextStyle(options?: { disabled?: boolean }) {
  return classNames(
    "cursor-pointer font-['Open_Sans'] text-[16px] font-semibold",
    options?.disabled && "cursor-not-allowed text-gray-400"
  );
}
